import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { tokenVerification } from "./Utils";

class MedicationDaysOfWeek extends Component {
    constructor() {
        super();
        this.state = {
            daysOfWeekList: [],
            pageNum: null,
            paginationValue: 10,
            isLoading : true, 
        }
    }
    componentDidMount() {
        // this.fetchDaysOfWeek();
        this.fetchAllDaysOfWeek();
    }

    fetchAllDaysOfWeek = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/all-schedule-daysOfWeek",
            method: 'GET',
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data: {
                medicationId: localStorage.getItem("medicationId")
            },
            success: function (res) {
                if (res.success === true) {
                    var allDaysOfweek = res.result;
                    thisController.state.daysOfWeekList = allDaysOfweek;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }


    notifyAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Schedule DaysOfWeek has been added successfully</b>, {
            position: "top-center",

        });

    };

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Schedule DaysOfWeek has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    notifyDataProcessing() {
        toast.warning("Hold on, your data is saving...", {
            position: "top-center",
            toastId: "notifyDataProcessing",
        });
    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }


    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp; Reminder deleted successfully</b>, {
            position: "top-center",
        });
    }

    openTimeOfDayPage = (row) => {
        localStorage.setItem("dayScheduleId", row.id)
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no days added for the medication. </p>
        </div>
    );

    render() {
        const { data } = this.state;


        const columns = [
            {
                name: <b style={{ fontSize: "17px"}}> Days Of Week </b>,
                // width: this.state.daysOfWeekWidth ? "75vw" : "65vw",
                selector: (row) => (
                    <div
                        style={{
                            display:
                                row.id == "" ? "none" : row.id != this.state.editedId
                                    ? "block"
                                    : "none",
                        }}
                        id="appearance-for-selected-days"
                    >
                        {(row.daysOfWeek && typeof row.daysOfWeek === 'string') && JSON.parse(row.daysOfWeek).length > 0 &&
                            (JSON.parse(row.daysOfWeek)).map((selectedDay, i) => (
                                <span key={i}>
                                    <button disabled={true}
                                        style={{ display: "inline", margin: "3px", fontSize: "12px" }}
                                        className="reminderBubble">
                                        {selectedDay}
                                    </button>
                                </span>
                            ))}
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: '16px' }}>Action</b>,
                width: 36,
                selector: (row) => (
                    <div id="action" style={{paddingLeft:"46%"}}>

                        <Link to="/projectmgmt/reports/time-of-day" onClick={(e) => { this.openTimeOfDayPage(row, e) }}>
                            <button title="Time of day"
                                className="btn action-button"
                            >
                                <img className="img-responsive" src={"./assets/images/schedule.png"} />
                            </button>
                        </Link>
                    </div>
                ),
            },
        ];
        return (

            <div style={{ marginRight: "1%"}}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="assets/css/buttonForm.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <link rel="stylesheet" href="assets/css/adminlte.css" />
                <link rel="stylesheet" href="assets/css/customDataTable.css" />

                <div className="row">
                    <div style={{ marginTop: '16px', marginLeft:"0.5vw"}}  >
                        <Link to="/projectmgmt/reports/medication-list">
                            <img src="./assets/images/arrow.svg"
                                style={{ paddingRight: "30%", cursor: 'pointer' }}
                            />
                        </Link>
                    </div>
                    <div >
                        <h6 className="nav-item" style={{ marginTop: '17px', fontSize:"17px" }}>
                            {localStorage.getItem("medicationTitle")}</h6>

                    </div>
                </div>
                {this.state.isLoading && (
                        <div style={{ padding: '20px', textAlign: 'center' , boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)"}}>
                            <p>Loading ...</p>
                        </div>
                    )}
                {!this.state.isLoading && this.state.daysOfWeekList.length === 0 && (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>There are no days added for the medication. </p>
                  </div>
                )}
                {this.state.daysOfWeekList.length > 0 && (<div style={{ marginTop: '3vh' , boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)"}}>

                    <DataTable
                        data={this.state.daysOfWeekList}
                        columns={columns}
                        noDataComponent={<this.CustomNoDataComponent />}
                    />

                </div>)}
            </div>
        )
    }
}

export default MedicationDaysOfWeek;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/MedicationDaysOfWeek.js